import React, { useState, useEffect, useCallback } from 'react'
import queryString from 'query-string'
import { isLoggedIn } from '@mc/user-info'
import { NOTHING, LOGIN, REGISTER, CONFIRM } from '../constants'
import AuthenticateModal from './AuthenticateModal'

const getInititalState = () => {
  const isLoggedOut = !isLoggedIn()
  const params = queryString.parse(window.location.search)

  if (params.require_signin && isLoggedOut) {
    return LOGIN
  }
  if (params.require_signup && isLoggedOut) {
    return REGISTER
  }
  if (params.needs_confirm) {
    return CONFIRM
  }

  return NOTHING
}

const Authentication = ({
  triggerRef,
  initialState = LOGIN,
  disableClose,
  ...props
}) => {
  const [view, setView] = useState(NOTHING)
  const [options, setOptions] = useState({})

  const show = useCallback(
    (newView, newOptions) => () => {
      setView(newView)
      setOptions({ ...options, ...newOptions })
    },
    [setView, setOptions, options],
  )

  const close = useCallback(
    (source, event) => {
      event.preventDefault()
      event.stopPropagation()
      setView(NOTHING)
    },
    [setView],
  )

  useEffect(() => {
    setView(getInititalState())
  }, [])

  // bind click events to `triggerRef` (Login Button)
  useEffect(() => {
    const trigger = triggerRef && triggerRef.current
    const handleLoginClick = () => show(initialState)()

    if (trigger) {
      trigger.addEventListener('click', handleLoginClick)
    }

    return () => {
      if (trigger) {
        trigger.removeEventListener('click', handleLoginClick)
      }
    }
  }, [triggerRef, show])

  if (view === NOTHING) return null

  return (
    <AuthenticateModal
      view={view}
      show={show}
      close={close}
      disableClose={disableClose}
      {...options}
      {...props}
    />
  )
}
export default Authentication
